import React from 'react'
import { WorkPeriod } from '../../../api/work-periods'
import { localDate } from '../../../utils/date'
import { PageNavigation } from '../../pages/page-navigation'
import WorkPeriodLink from '../work-period-link'

interface WorkPeriodPageNavigationProps {
  /** Mission ID for building prev/next links. */
  missionId: string
  /** Previous work period (e.g. from useWorkPeriodsQuery list including virtuals). */
  previousWorkPeriod: WorkPeriod | undefined
  /** Next work period (e.g. from useWorkPeriodsQuery list including virtuals). */
  nextWorkPeriod: WorkPeriod | undefined
}

export const WorkPeriodPageNavigation: React.FC<WorkPeriodPageNavigationProps> = ({
  missionId,
  previousWorkPeriod,
  nextWorkPeriod,
}) => (
  <PageNavigation
    items={[previousWorkPeriod, nextWorkPeriod]}
    labelBuilder={wp => localDate(wp.start.date)}
    linkBuilder={wp => `/missions/${missionId}/work-periods/${wp._id}`}
    renderLink={(wp, content, { direction }) => (
      <span data-test={`page-navigation-${direction}`}>
        <WorkPeriodLink workPeriod={wp} style={{ display: 'inline-flex' }} textColor="link">
          {content}
        </WorkPeriodLink>
      </span>
    )}
  />
)
